export default "__VITE_ASSET__cd51ee12__"